export const language_ko={
    "nav.home": "홈",
    "nav.cexs": "CEXs 및 코어 팀",
    "nav.operations": "작업",
    "nav.transactions": "거래",
    "nav.blocks": "블록",
    "nav.nodes": "노드",
    "nav.stats": "통계",
    "stats.accounts": "계정 분포",
    "stats.unlocks": "Pi 잠금 해제 통계",
    "stats.unlocks_monthly": "월간 Pi 잠금 해제 통계",
    'stats.domain_auction': 'Pi 도메인 경 매 통계',
    "stats.largest_tx": "최대 거래",
    "stats.migrate": "메인넷 이동 통계",
    "nav.report_scam": "사기 신고",
    "search.placeholder": "검색...",
    'operations.self_transfer': '자체 송금',
    'operations.domain_auction': '도메인 경매',
    "operations.claim_claimable_balance": "π 수령",
    "operations.create_account": "계정 생성",
    "operations.payment": "결제",
    "operations.path_payment_strict_receive": "엄격한 수신 경로 결제",
    "operations.path_payment_strict_send": "엄격한 송신 경로 결제",
    "operations.manage_sell_offer": "판매 제안 관리",
    "operations.create_passive_sell_offer": "수동 판매 제안 생성",
    "operations.set_options": "옵션 설정",
    "operations.change_trust": "신뢰 변경",
    "operations.allow_trust": "신뢰 허용",
    "operations.account_merge": "계정 병합",
    "operations.inflation": "인플레이션",
    "operations.manage_data": "데이터 관리",
    "operations.bump_sequence": "시퀀스 증가",
    "operations.manage_buy_offer": "구매 제안 관리",
    "operations.create_passive_buy_offer": "수동 구매 제안 생성",
    "operations.create_claimable_balance": "수령 가능 잔액 생성",
    "operations.claim_claimable_balance_atom": "수령 가능 잔액 수령",
    "operations.deposit": "입금",
    "operations.withdraw": "출금",
    "operations.pay": "지불",
    "operations.to": "대상",
    "operations.from": "출발",
    "operations.claimant": "수령자",
    "operations.with_starting_balance": "초기 잔액 포함",
    "operations.claim": "수령",
    "operations.heading": "Pi 네트워크 블록체인의 최신 작업 탐색",
    "operations.title": "Pi 네트워크의 최신 작업",
    "operations.description": "Pi 네트워크 블록체인의 최신 작업을 탐색하세요.",
    "operations.source_account": "소스 계정",
    "operations.operation": "작업",
    "operations.amount": "금액",
    "operations.tx": "거래",
    "operations.time": "시간",
    "pagination.previous": "이전",
    "pagination.next": "다음",
    "pagination.page": "페이지",
    "account.title": "계정 {{address}} - Pi 네트워크 탐색기",
    "account.heading": "계정 상세정보",
    "account.heading_with_address": "계정 {{address}}",
    "account.description": "Pi 네트워크의 계정 {{address}} 상세정보입니다.",
    "account.loading": "계정 상세정보 로딩 중...",
    "account.not_found": "계정을 찾을 수 없습니다.",
    "account.scam_warning_title": "사기 경고",
    "account.scam_warning_description": "이 지갑 주소는 커뮤니티 보고에 따라 안전하지 않은 것으로 표시되었습니다. 사기, 개인 키 손상 또는 무단 액세스와 관련이 있을 수 있습니다. 거래를 하기 전에 주의하세요.",
    "account.overview": "개요",
    "account.available_balance": "사용 가능한 잔액",
    "account.last_modified_time": "마지막 수정 시간",
    "account.locking": "잠금",
    "account.total_locking": "총 잠금 ({{count}}개 항목)",
    "account.next_unlock_time": "다음 잠금 해제 시간",
    "account.claimable": "수령 가능",
    "account.amount": "금액",
    "account.number_of_items": "항목 수",
    "account.over_100_items": "100개 이상 항목",
    "account.tx_hash": "트랜잭션 해시",
    "account.operation_count": "작업 수",
    "account.fee": "수수료",
    "account.created_at": "생성 시간",
    "account.account": "계정",
    "account.effect": "효과",
    "account.sponsor": "스폰서",
    "account.predicate": "조건",
    "account.create_time": "생성 시간",
    "account.latest_100_claimable": "최근 100개 수령 가능 잔액",
    "account.tabs.operations": "작업",
    "account.tabs.transactions": "트랜잭션",
    "account.tabs.effects": "효과",
    "account.tabs.claimable_balances": "수령 가능 잔액",
    "effects.account_credited": "계정 입금",
    "effects.account_debited": "계정 출금",
    "effects.account_created": "계정 생성",
    "effects.claimable_balance_created": "수령 가능 잔액 생성",
    "effects.claimable_balance_claimed": "수령 가능 잔액 수령됨",
    "effects.claimable_balance_claimant_created": "수령 가능 잔액 수령자 생성",
    "effects.account_removed": "계정 삭제됨",
    "effects.account_thresholds_updated": "계정 임계값 업데이트됨",
    "effects.account_home_domain_updated": "계정 홈 도메인 업데이트됨",
    "effects.account_flags_updated": "계정 플래그 업데이트됨",
    "effects.account_inflation_destination_updated": "계정 인플레이션 대상 업데이트됨",
    "effects.signer_created": "서명자 생성됨",
    "effects.signer_removed": "서명자 제거됨",
    "effects.signer_updated": "서명자 업데이트됨",
    "effects.trustline_created": "신뢰선 생성됨",
    "effects.trustline_removed": "신뢰선 제거됨",
    "effects.trustline_updated": "신뢰선 업데이트됨",
    "effects.trustline_authorized": "신뢰선 승인됨",
    "effects.trustline_deauthorized": "신뢰선 승인 취소됨",
    "effects.offer_created": "제안 생성됨",
    "effects.offer_removed": "제안 제거됨",
    "effects.offer_updated": "제안 업데이트됨",
    "effects.trade": "거래 실행됨",
    "effects.data_created": "데이터 생성됨",
    "effects.data_removed": "데이터 제거됨",
    "effects.data_updated": "데이터 업데이트됨",
    "effects.sequence_bumped": "시퀀스 증가됨",
    "effects.liquidity_pool_created": "유동성 풀 생성됨",
    "effects.liquidity_pool_removed": "유동성 풀 제거됨",
    "effects.liquidity_pool_deposited": "유동성 풀 입금됨",
    "effects.liquidity_pool_withdrew": "유동성 풀 출금됨",
    "effects.liquidity_pool_trade": "유동성 풀 거래",
    "effects.liquidity_pool_revoked": "유동성 풀 취소됨",
    "effects.contract_credited": "계약 입금됨",
    "effects.contract_debited": "계약 출금됨",
    "effects.claimable_balance_sponsorship_removed": "수령 가능 잔액 스폰서십 제거됨",
    "account_stats.heading": "Pi 계정 통계 - 잔액 분포 및 상위 계정",
    "account_stats.title": "Pi 계정 통계 - 잔액 분포 및 상위 계정",
    "account_stats.description": "Pi 네트워크에서 가장 부유한 Pi 계정과 전반적인 잔액 분포를 확인하세요.",
    "account_stats.intro_text": "모든 계정에 걸친 Pi의 분포를 탐색하고 상위 Pi 보유자를 확인하세요.",
    "account_stats.distribution_chart_title": "Pi 보유자 분포",
    "account_stats.categories_title": "분포 카테고리",
    "account_stats.top_accounts_title": "상위 Pi 계정",
    "account_stats.accounts": "계정",
    "account_stats.of_total": "전체 중",
    "account_stats.table.category": "카테고리",
    "account_stats.table.balance_range": "잔액 범위",
    "account_stats.table.usd_value": "USD 가치",
    "account_stats.table.accounts": "계정",
    "account_stats.table.percentage": "전체 중 %",
    "account_stats.table.total": "합계",
    "account_stats.table.rank": "순위",
    "account_stats.table.account": "계정",
    "account_stats.table.balance": "잔액",
    "account_stats.table.value": "가치",
    "account_stats.table.supply_percentage": "공급량 중 %",
    "account_stats.categories.whales": "고래",
    "account_stats.categories.sharks": "상어",
    "account_stats.categories.dolphins": "돌고래",
    "account_stats.categories.tunas": "참치",
    "account_stats.categories.fish": "물고기",
    "account_stats.categories.shrimps": "새우",
    "account_stats.categories.plankton": "플랑크톤",
    "account_stats.categories.microbes": "미생물",
    "number.billion_short": "십억",
    "number.million_short": "백만",
    "number.thousand_short": "천",
    "common.loading": "로딩 중...",
    "common.sponsored": "스폰서",
    "common.ad": "광고",
    "common.ad_not_available": "귀하의 지역에서 스폰서 콘텐츠를 이용할 수 없습니다",
    "blocks.heading": "Pi 네트워크 블록체인의 최신 블록 탐색",
    "blocks.title": "Pi 네트워크의 최신 블록",
    "blocks.description": "Pi 네트워크 블록체인의 최신 블록을 탐색하세요.",
    "blocks.sequence": "시퀀스",
    "blocks.hash": "해시",
    "blocks.transactions": "트랜잭션",
    "blocks.operations": "작업",
    "blocks.time": "시간",
    "blocks.successful": "성공",
    "blocks.failed": "실패",
    "block.title": "블록 #{{sequence}} - Pi 네트워크 탐색기",
    "block.heading": "블록 #{{sequence}}",
    "block.description": "Pi 네트워크 블록체인의 블록 #{{sequence}} 상세 정보.",
    "block.loading": "블록 상세 정보 로딩 중...",
    "block.not_found": "블록을 찾을 수 없습니다.",
    "block.information": "블록 정보",
    "block.hash": "해시",
    "block.previous_hash": "이전 해시",
    "block.sequence": "시퀀스",
    "block.time": "시간",
    "block.total_coins": "총 코인",
    "block.fee_pool": "수수료 풀",
    "block.base_fee": "기본 수수료",
    "block.base_reserve": "기본 예비금",
    "block.protocol_version": "프로토콜 버전",
    "block.tx_hash": "트랜잭션 해시",
    "block.operation_count": "작업 수",
    "block.fee": "수수료",
    "block.created_at": "생성 시간",
    "block.tabs.transactions": "트랜잭션",
    "block.tabs.operations": "작업",
    "block.tabs.effects": "효과",
    "cex.heading": "CEX 및 코어 팀 계정 통계",
    "cex.title": "Pi 네트워크의 CEX 및 코어 팀 계정",
    "cex.description": "Pi 네트워크 블록체인의 CEX 및 코어 팀 계정을 탐색하세요.",
    "cex.wallet_balances": "CEX 지갑 잔액",
    "cex.core_team_wallets": "Pi 코어 팀 지갑",
    "cex.cmc_ranking": "CMC 순위",
    "cex.exchange": "거래소",
    "cex.chart_link": "차트 링크",
    "cex.signup_link": "가입 링크",
    "cex.wallet_address": "지갑 주소",
    "cex.balance_pi": "잔액 (Pi)",
    "cex.balance_usd": "잔액 (USD)",
    "cex.chart": "차트",
    "cex.signup": "가입",
    "cex.total": "총합",
    "cex.note": "참고",
    "cex.pi_foundation": "Pi 재단",
    "cex.team_wallet_footnote": "다량의 계정과 매우 적은 거래로 인해 여기에 나열되지 않은 Pi 코어 팀에 속하는 것으로 레이블이 지정된 약 10,000개의 계정이 있습니다. 각 지갑은 약 2,000,000 Pi를 보유하고 있으며, 총 약 200억 Pi가 계산되지 않았습니다.",
    'cex.total_in': '총 입금 (최근 24시간)',
'cex.total_out': '총 출금 (최근 24시간)',
'cex.net_difference': '순 흐름 (최근 24시간)',
'cex.flow_data_updated': '데이터는 30분마다 갱신됩니다',
'cex.flow_note': '최근 24시간 기준 데이터입니다. 30분마다 자동 갱신됩니다.',
    "contact.heading": "문의하기",
    "contact.title": "PiScan에 문의하기",
    "contact.description": "질문이나 피드백이 있으시면 PiScan에 문의하세요.",
    "contact.intro_text": "질문이 있으시면 다음 주소로 연락해 주세요",
    "contact.success_message": "문의해 주셔서 감사합니다! 곧 답변 드리겠습니다.",
    "contact.form.name": "이름",
    "contact.form.email": "이메일",
    "contact.form.message": "메시지",
    "contact.form.submit": "메시지 보내기",
    "home.heading": "Pi 네트워크 거래, 지갑 및 통계 탐색",
    "home.title": "Pi 네트워크 거래, 지갑 및 통계 탐색",
    "home.description": "Pi 네트워크 거래, 지갑 및 통계 탐색",
    "home.market_cap": "시가총액",
    "home.price": "가격",
    "home.24h_change": "24시간 변동",
    "home.pi_supply": "Pi 공급량",
    "home.circulating": "유통량",
    "home.locked": "잠금량",
    "home.cex_balance_total": "CEX 잔액 (총)",
    "home.view_all": "모두 보기",
    "home.network_stats": "네트워크 통계",
    "home.blocks": "블록",
    "home.tps": "TPS",
    "home.latest_transactions": "최근 거래",
    "home.signature": "서명",
    "home.time": "시간",
    "home.block": "블록",
    "home.ops": "작업 수",
    "home.latest_operations": "최근 작업",
    "home.source_account": "소스 계정",
    "home.operation": "작업",
    "home.amount": "금액",
    "home.tx": "거래",
    "nodes.heading": "Pi 네트워크 노드 맵 및 네트워크 통계",
    "nodes.title": "Pi 네트워크 노드 및 검증자",
    "nodes.description": "Pi 네트워크 노드, 검증자 및 네트워크 토폴로지를 탐색하세요. 노드의 전 세계 분포 및 연결성을 확인하세요.",
    "nodes.active_nodes": "활성 노드",
    "nodes.validators": "검증자",
    "nodes.known_peers": "알려진 피어",
    "nodes.disconnected_nodes": "연결 끊긴 노드",
    "nodes.network_graph": "네트워크 그래프",
    "nodes.node_types": "노드 유형",
    "nodes.validator": "검증자",
    "nodes.watcher": "관찰자",
    "nodes.disconnected_private": "연결 끊김/비공개",
    "nodes.click_to_highlight": "노드를 클릭하여 연결을 강조 표시",
    "nodes.global_distribution": "전 세계 분포",
    "nodes.mapped_nodes": "지도에 표시된 노드",
    "nodes.node_details": "노드 세부 정보",
    "nodes.nodes": "노드",
    "nodes.address": "주소",
    "nodes.type": "유형",
    "nodes.location": "위치",
    "nodes.isp": "인터넷 서비스 제공업체",
    "nodes.version": "버전",
    "nodes.trust": "신뢰",
    "nodes.trusted_by": "신뢰 수",
    "nodes.status": "상태",
    "nodes.status.connected": "연결됨",
    "nodes.status.disconnected": "연결 끊김",
    "nodes.status.private": "비공개",
    "nodes.active_quorum_sets": "활성 쿼럼 세트",
    "nodes.active": "활성",
    "nodes.quorum_hash": "쿼럼 해시",
    "nodes.node_id": "노드 ID",
    "nodes.unknown": "알 수 없음",
    "nodes.core_team": "코어 팀",
    "nodes.tooltip.node_id": "노드 ID",
    "nodes.tooltip.address": "주소",
    "nodes.tooltip.type": "유형",
    "nodes.tooltip.status": "상태",
    "nodes.tooltip.version": "버전",
    "nodes.tooltip.location": "위치",
    "nodes.tooltip.not_accessible": "접근 불가",
    "report_scam.heading": "사기 지갑 신고",
    "report_scam.title": "PiScan에서 사기 지갑 신고",
    "report_scam.description": "사기 또는 부정 행위와 관련된 지갑 주소를 신고하세요.",
    "report_scam.intro_text": "사기 또는 부정 행위와 관련된 의심스러운 지갑 주소를 발견하셨다면, 아래 양식을 사용하여 신고해 주세요. 저희 팀이 제출 내용을 검토하고, 사기로 확인되면 커뮤니티에 경고하기 위해 PiScan에서 해당 지갑을 \"사기\"로 표시할 것입니다.",
    "report_scam.success_message": "신고해 주셔서 감사합니다! 저희 팀이 가능한 한 빨리 검토하겠습니다.",
    "report_scam.form.wallet_address": "지갑 주소",
    "report_scam.form.wallet_placeholder": "사기 지갑 주소를 입력하세요",
    "report_scam.form.reason": "신고 이유",
    "report_scam.form.reason_placeholder": "이 지갑이 사기 활동으로 의심되는 이유를 설명하세요",
    "report_scam.form.email": "이메일 (선택사항)",
    "report_scam.form.email_placeholder": "이메일을 입력하세요 (선택사항)",
    "report_scam.form.email_note": "추가 정보를 위해 연락드릴 수 있습니다.",
    "report_scam.form.submit": "신고 제출",
    "transaction.title": "Pi 네트워크의 트랜잭션 #{{id}}",
    "transaction.heading": "트랜잭션 세부정보",
    "transaction.description": "Pi 네트워크 블록체인의 트랜잭션 #{{id}} 세부정보입니다.",
    "transaction.loading": "트랜잭션 세부정보를 로드 중...",
    "transaction.not_found": "트랜잭션을 찾을 수 없습니다.",
    "transaction.hash": "해시",
    "transaction.ledger_block": "원장 (블록)",
    "transaction.result": "결과",
    "transaction.source_account": "소스 계정",
    "transaction.fee_account": "수수료 계정",
    "transaction.fee": "수수료",
    "transaction.operation_count": "작업 수",
    "transaction.summary": "요약",
    "transaction.operations": "작업",
    "transaction.effects": "효과",
    "transaction.account": "계정",
    "transaction.operation": "작업",
    "transaction.effect": "효과",
    "transaction.amount": "금액",
    "transaction.successful": "성공",
    "transaction.failed": "실패",
    "transaction.loading_details": "트랜잭션 세부정보를 로드 중...",
    "transaction.with_operations": "{{count}}개 작업이 포함된 트랜잭션",
    "transaction.core_team_distributed": "Pi 코어 팀이 배포함",
    "transaction.to": "대상",
    "transaction.accounts": "계정",
    "transaction.locked_for_days": ", {{days}}일 동안 잠금됨",
    "transaction.locked_range_days": ", 잠금 기간은 {{minDays}}일에서 {{maxDays}}일까지 다양함",
    "transaction.created_at": "생성 시간",
    "unlock_stats.heading": "Pi 잠금 해제 통계 - 향후 30일",
    "unlock_stats.title": "Pi 잠금 해제 통계 - 향후 30일",
    "unlock_stats.description": "향후 30일 동안의 예상 Pi 암호화폐 잠금 해제 통계를 확인하세요.",
    "unlock_stats.intro_text": "향후 30일 동안의 Pi 잠금 해제는 사용자가 잠근 것이나 Pi 코어 팀이 배포한 수령 가능 잔액을 기반으로 합니다. 아직 수령 가능 잔액에 포함되지 않은 미공개 Pi는 추적할 수 없습니다. 정기적으로 업데이트를 확인하세요. 모든 시간은 UTC입니다.",
    "unlock_stats.today_note": "오늘의 잠금 해제 금액은 지금부터 하루가 끝날 때까지(UTC) 잠금 해제될 남은 Pi를 나타냅니다.",
    "unlock_stats.updated_at": "데이터 업데이트:",
    "unlock_stats.unknown": "알 수 없음",
    "unlock_stats.total_locked": "총 잠긴 Pi",
    "unlock_stats.total_next_30": "향후 30일 총 잠금 해제",
    "unlock_stats.of_total_locked": "총 잠긴 금액의",
    "unlock_stats.avg_daily": "일일 평균 잠금 해제",
    "unlock_stats.per_day": "일일",
    "unlock_stats.highest_day": "최고 일자",
    "unlock_stats.on": "날짜",
    "unlock_stats.chart_title": "Pi 잠금 해제 차트 - 향후 30일",
    "unlock_stats.data_table": "잠금 해제 데이터 테이블",
    "unlock_stats.date": "날짜",
    "unlock_stats.amount": "금액",
    "unlock_stats.value": "가치",
    "unlock_stats.pi_unlock": "Pi 잠금 해제",
    "unlock_stats.y_axis_label": "Pi 잠금 해제 (백만 단위)",
    "unlock_stats.monthly_heading": "월별 Pi 언락 통계",
    "unlock_stats.monthly_title": "월별 Pi 언락 통계",
    "unlock_stats.total_next_12": "향후 12개월 총 잠금 해제",
    "unlock_stats.monthly_description": "월별 Pi 암호화폐 언락 통계를 확인하세요",
    "unlock_stats.monthly_intro_text": "월별 Pi 암호화폐 언락 통계를 확인하세요.",
    "unlock_stats.monthly_note": "통계는 유효한 언락 요청을 기준으로 합니다.",
    "unlock_stats.monthly_chart_title": "월별 Pi 언락 통계 차트",
    "unlock_stats.total_forecast": "총 통계",
    "unlock_stats.monthly_data_table": "월별 언락 데이터",
    "unlock_stats.total_locking": "총 잠금 수량",
    "unlock_stats.avg_monthly": "월평균",
    "unlock_stats.highest_month": "최고 언락 월",
    "unlock_stats.per_month": "월별",
    "unlock_stats.in": "내",
    "unlock_stats.month": "월",
    "unlock_stats.view_daily": "일별 언락 통계 보기",
    "unlock_stats.view_monthly": "월별 언락 통계 보기",
    "common.loading_error": "데이터를 로드하는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.",
    'settings.aria_label': '설정 열기',
    'settings.language': '언어',
    'settings.appearance': '외관',
    'settings.dark_mode': '다크 모드',
    'settings.light': '라이트',
    'settings.dark': '다크',

    "transactios.heading": "Pi 네트워크 블록체인의 최신 거래 탐색",
    "transactions.title": "Pi 네트워크의 최신 거래",
    "transactions.description": "Pi 네트워크 블록체인의 최신 거래를 탐색하세요.",
      "domain_auction_stats.heading": "Pi 도메인 경매 통계",
      "domain_auction_stats.title": "Pi 도메인 경매 통계 | Pi 네트워크 통계",
      "domain_auction_stats.description": "Pi 네트워크 도메인 경매 분석, 다양한 가격대별 입찰 분포 및 총 입찰된 Pi를 표시합니다.",
      "domain_auction_stats.intro_text": "이 페이지는 Pi 도메인 경매에 대한 분석을 제공하며, 다양한 가격대별 입찰 분포를 강조합니다.",
      "domain_auction_stats.last_updated": "최종 업데이트",
      "domain_auction_stats.summary_title": "경매 입찰 요약",
      "domain_auction_stats.total_bids": "총 입찰 수",
      "domain_auction_stats.total_pi_bid": "총 입찰된 Pi",
      "domain_auction_stats.estimated_value": "예상 가치 (USD)",
      "domain_auction_stats.pi_price": "현재 Pi 가격",
      "domain_auction_stats.distribution_title": "입찰 분포",
      "domain_auction_stats.chart_title": "입찰 가격 분포",
      "domain_auction_stats.details_title": "실시간 입찰 내역",
      "domain_auction_stats.bids": "입찰",
      "domain_auction_stats.of_total": "총 입찰 중",
      "domain_auction_stats.bid_count": "입찰 수",
      "domain_auction_stats.ranges.low": "낮은 입찰",
      "domain_auction_stats.ranges.medium": "일반 입찰",
      "domain_auction_stats.ranges.high": "고급 입찰",
      "domain_auction_stats.ranges.premium": "프리미엄 입찰",
      "domain_auction_stats.ranges.elite": "최상급 입찰",
      "domain_auction_stats.table.price_range": "입찰 가격 범위",
      "domain_auction_stats.table.bid_count": "입찰 수",
      "domain_auction_stats.table.percentage": "비율",
      "domain_auction_stats.table.total": "총 입찰",
      "domain_auction_stats.highest_bid": "최고 입찰가",
      "domain_auction_stats.top_bids_title": "최고 입찰 목록",
      "domain_auction_stats.table.account": "계정",
      "domain_auction_stats.table.bid_amount": "입찰 금액",
      "domain_auction_stats.table.usd_value": "USD 가치",      
      "largest_tx.heading": "최대 Pi 거래 (최근 24시간)",
"largest_tx.title": "최근 24시간 동안의 최대 Pi 거래 - PiScan",
"largest_tx.description": "최근 24시간 동안 Pi Network 블록체인에서 가장 큰 Pi 거래를 탐색하세요.",
"largest_tx.list_heading": "거래량 기준 상위 거래 (최근 24시간)",
"largest_tx.rank": "순위",
"largest_tx.transaction": "거래",
"largest_tx.account": "계정",
"largest_tx.amount": "수량 (π)",
"largest_tx.date": "날짜 & 시간",
"largest_tx.no_data": "최근 24시간 동안 거래 데이터가 없습니다.",
"largest_tx.fetch_error": "거래 데이터를 불러올 수 없습니다.",
"largest_tx.loading": "최대 거래 로딩 중...",
"largest_tx.largest_amount": "최대 거래 금액 (최근 24시간)",
"largest_tx.latest_large_tx": "최근 대규모 거래 (최근 24시간)",
"largest_tx.total_value": "총 가치 (상위 100개 거래, 최근 24시간)",

"migrate_stats.heading": "Pi 이동 통계",
"migrate_stats.title": "Pi 메인넷 마이그레이션 통계 - PiScan",
"migrate_stats.description": "최근 며칠 동안의 Pi 메인넷 이동 통계를 추적하세요.",
"migrate_stats.last_updated": "마지막 업데이트",

"migrate_stats.daily_migration": "일일 Pi 이동량",
"migrate_stats.daily_stats": "일별 이동 통계",
"migrate_stats.loading": "이동 통계 로딩 중...",
"migrate_stats.no_data": "이동 데이터가 없습니다.",
"migrate_stats.fetch_error": "이동 데이터를 불러올 수 없습니다.",
"migrate_stats.date": "날짜",
"migrate_stats.amount": "수량 (π)",
"migrate_stats.percentage": "비율 (%)",
"migrate_stats.total": "총계",
"migrate_stats.pi_migrated": "총 이동된 Pi",
"migrate_stats.date_label": "날짜: {{date}}",
"migrate_stats.usd_value": "USD 가치",
"migrate_stats.at_price": "현재 가격 기준",
"migrate_stats.current_price_note": "USD 가치는 현재 Pi 가격 {{price}} π 당 기준으로 계산됩니다.",

"transactions_filter.heading": "거래 필터",
"transactions_filter.title": "거래 필터 | Pi Scan",
"transactions_filter.description": "주소, 금액 및 기타 기준에 따라 Pi Network 거래를 필터링하고 검색합니다.",
"transactions_filter.address_required_error": "주소를 입력해야 합니다.",
"transactions_filter.min_amount_required_error": "최소 금액을 입력해야 합니다.",
"transactions_filter.amount_too_low_error": "금액은 10,000보다 작을 수 없습니다.",
"transactions_filter.min_exceeds_max_error": "최소 금액은 최대 금액을 초과할 수 없습니다.",
"transactions_filter.filter_options": "필터 옵션",
"transactions_filter.address": "주소",
"transactions_filter.address_placeholder": "계정 주소 입력",
"transactions_filter.min_amount": "최소 금액 (Pi)",
"transactions_filter.min_amount_placeholder": "예: 10000",
"transactions_filter.max_amount": "최대 금액 (Pi)",
"transactions_filter.max_amount_placeholder": "예: 100000",
"transactions_filter.apply_filters": "적용",
"transactions_filter.clear": "초기화",
"transactions_filter.no_results": "조건에 맞는 거래를 찾을 수 없습니다.",
"transactions_filter.results": "결과",
"transactions_filter.table.hash": "거래 해시",
"transactions_filter.table.time": "시간",
"transactions_filter.table.from": "보낸 주소",
"transactions_filter.table.to": "받는 주소",
"transactions_filter.table.amount": "금액 (Pi)",
"transactions_filter.apply_filters_prompt": "결과를 보려면 필터를 적용하세요."
}